var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("a-tabs", {
    attrs: {
      activeKey: _vm.activeKey
    },
    on: {
      change: _vm.tabChange
    }
  }, [_c("a-tab-pane", {
    key: 1,
    attrs: {
      tab: _vm.$t("基本信息")
    }
  }, [_c("information", {
    key: _vm.activeKey,
    attrs: {
      id: _vm.id
    },
    on: {
      next: _vm.nextFun
    }
  })], 1), _c("a-tab-pane", {
    key: 2,
    attrs: {
      tab: _vm.$t("产品方案")
    }
  }, [_c("plan-list", {
    key: _vm.activeKey,
    attrs: {
      id: _vm.id
    },
    on: {
      prev: _vm.prevFun
    }
  })], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };